import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions, useRefetchQuery } from "libs/reactQuery";

import { requestUpdateReseller } from "./updateReseller.request";
import { UpdateResellerBody } from "./updateReseller.types";

const useUpdateReseller = (
  resellerId?: string,
  options?: MutationOptions<void, ApiServiceError<ApiError>, UpdateResellerBody>
) => {
  const refetchReseller = useRefetchQuery(["reseller", String(resellerId)]);

  return useMutation({
    mutationFn: requestUpdateReseller,
    ...options,
    onSuccess: (...args) => {
      refetchReseller();
      options?.onSuccess?.(...args);
    }
  });
};

export default useUpdateReseller;
